/**
 * Волна D (docs/MIGRATION_ROUTER.md §5).
 * Было: <PrivateRoute exact path='/cart'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Cart from '@routes/Cart';

export const Route = createFileRoute('/cart/')({
  staticData: { layout: { addMobileMargin: true } },
  component: () => (
    <CacheDataRoute component={Cart} path='/cart' />
  )
});
